import { onReady } from '@/core/utils/dom';

const RESIZE_TIMEOUT = 150;
let resizeTimer: ReturnType<typeof setTimeout>;

function calculateScrollbarSize() {
	const scroller = document.scrollingElement;

	if (!scroller) return;
	if (!(scroller instanceof HTMLElement)) return;

	// Temporarily force scrollbars to appear without making content jump
	const originalOverflow = scroller.style.overflow;
	scroller.style.overflow = 'scroll';

	requestAnimationFrame(() => {
		const size = Math.max(window.innerWidth - scroller.clientWidth, 0);

		document.documentElement.style.setProperty(
			'--scrollbar-width',
			`${size}px`,
		);

		scroller.style.overflow = originalOverflow;
	});
}

const elementList = ['footer', 'header'];
const url = new URL(window.location.href);

for (const element of elementList) {
	const param = url.searchParams.get(element);

	if (!param) continue;
	if (param !== 'false') continue;

	document.documentElement.classList.add(`hide-${element}`);
}

window.addEventListener('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(calculateScrollbarSize, RESIZE_TIMEOUT);
});

onReady(calculateScrollbarSize);
